//@flow
//Action Type Registered
export const OPEN_ADD_INV_ITEM_FORM='DM_OPEN_ADD_INV_ITEM_FORM';
export const CANCEL_ADD_INV_ITEM_FORM='DM_CANCEL_ADD_INV_ITEM_FORM';
export const REFRESH_DEMETER_VENDORS_SUCCESS='REFRESH_DEMETER_VENDORS_SUCCESS';
export const REFRESH_DEMETER_VENDORS_ERROR='REFRESH_DEMETER_VENDORS_ERROR';
export const REFRESH_DEMETER_STORE_LOCATIONS_SUCCESS='REFRESH_DEMETER_STORE_LOCATIONS_SUCCESS';
export const REFRESH_DEMETER_STORE_LOCATIONS_ERROR='REFRESH_DEMETER_STORE_LOCATIONS_ERROR';
export const GET_DEMETER_ITEMS_SUCCESS='GET_DEMETER_ITEMS_SUCCESS';
export const GET_DEMETER_ITEMS_ERROR='GET_DEMETER_ITEMS_ERROR';
export const CREATE_NEW_DEMETER_ITEM_SUCCESS='CREATE_NEW_DEMETER_ITEM_SUCCESS';
export const CREATE_NEW_DEMETER_ITEM_ERROR='CREATE_NEW_DEMETER_ITEM_ERROR';
export const EDIT_DEMETER_ITEM='EDIT_DEMETER_ITEM';
export const UPDATE_DEMETER_ITEM_SUCCESS='UPDATE_DEMETER_ITEM_SUCCESS';
export const UPDATE_DEMETER_ITEM_ERROR='UPDATE_DEMETER_ITEM_ERROR';
export const MOVE_DOWN_DEMETER_ITEM_SUCCESS='MOVE_DOWN_DEMETER_ITEM_SUCCESS';
export const MOVE_DOWN_DEMETER_ITEM_ERROR='MOVE_DOWN_DEMETER_ITEM_ERROR';
export const MOVE_UP_DEMETER_ITEM_SUCCESS='MOVE_UP_DEMETER_ITEM_SUCCESS';
export const MOVE_UP_DEMETER_ITEM_ERROR='MOVE_UP_DEMETER_ITEM_ERROR';
export const DELETE_DEMETER_ITEM_SUCCESS='DELETE_DEMETER_ITEM_SUCCESS';
export const DELETE_DEMETER_ITEM_ERROR='DELETE_DEMETER_ITEM_ERROR';
export const SELECTED_DEMETER_ITEM_ID='SELECTED_DEMETER_ITEM_ID';
export const REFRESH_DEMETER_ITEM='REFRESH_DEMETER_ITEM';
export const DEMETER_INV_SUBMIT_SUCCESS='DEMETER_INV_SUBMIT_SUCCESS';
export const DEMETER_INV_SUBMIT_ERROR='DEMETER_INV_SUBMIT_ERROR';
export const DEMETER_INV_SUBMITTED_COMPLETED='DEMETER_INV_SUBMITTED_COMPLETED';
export const DEMETER_EDIT_VERIFY_FORM_DATA_SUCCESS='DEMETER_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const DEMETER_EDIT_VERIFY_FORM_DATA_ERROR='DEMETER_EDIT_VERIFY_FORM_DATA_ERROR'
export const DEMETER_UPDATE_FORM_ERROR='DEMETER_UPDATE_FORM_ERROR'


// WEBPACK FOOTER //
// ./src/redux/demeter/actionTypes.js